import {
    takeLatest
} from 'redux-saga/effects';

import { sendInitialAnalytics } from 'domain/Analytics/sagas';
import { NEW_PLAN } from '../constants';

export function* newPlan() {
  yield sendInitialAnalytics();
}

export default function* newPlanSaga() {
  yield takeLatest(NEW_PLAN, newPlan);
}
